import { render, staticRenderFns } from "./DataTable3.vue?vue&type=template&id=071cff59&scoped=true"
import script from "./DataTable3.vue?vue&type=script&lang=js"
export * from "./DataTable3.vue?vue&type=script&lang=js"
import style0 from "./DataTable3.vue?vue&type=style&index=0&id=071cff59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071cff59",
  null
  
)

export default component.exports